export default __webpack_public_path__ + "static/media/9_Still.18a5aa7c.jpg";